import { render, staticRenderFns } from "./LogaFooter.vue?vue&type=template&id=047aec1d&scoped=true"
import script from "./LogaFooter.vue?vue&type=script&lang=js"
export * from "./LogaFooter.vue?vue&type=script&lang=js"
import style0 from "./LogaFooter.vue?vue&type=style&index=0&id=047aec1d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047aec1d",
  null
  
)

export default component.exports